const initRepoState = {
  loading: {},
  dataTablesResponse: {},
}

const repositoryReducer = (state = initRepoState, action: any) => {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.key]: action.loading,
        },
      }
    case 'SET_DATATABLES_RESPONSE':
      return {
        ...state,
        dataTablesResponse: {
          ...state.dataTablesResponse,
          [action.key]: action.data,
        },
      }
    default:
      return {...state}
  }
}

export default repositoryReducer
